import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card, Typography, Button, /*Avatar*/ } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { useDispatch, useSelector } from "react-redux";
import { preAfiliacionesTomadasLimpiar, fetchPreAfilicionesTomadas, liberarPreAfiliacion } from "../../actions/preafiliacionesTomadas";
import { ADMINISTRAR_PREAFILIACIONES_PERMISOS } from "../../utils/permisos";
import { validarSoloUnPermiso } from "../../helpers/permisos";
//const baseUrl = process.env.REACT_APP_URL;

const useStyles = makeStyles({
  card: {
    padding: 20,
    height: 480,
    width: 1010,
    marginTop: 50,
    marginBottom: 20,
  },
  tableTitle: {
    marginBottom: 15,
  },
  button: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

export const AdministrarPreAfiliaciones = (props) => {

  const classes = useStyles();
  const dispatch = useDispatch();

  const { items, cargada } = useSelector((state) => state.preAfiliacionesTomadas);
  //const { idSeccional } = useSelector((state) => state.auth);
  const { permisos: permisosUser, idUsuario } = useSelector((state) => state.auth);
  //Ahora filtra por API
  const preAfiliacionesFiltradas = items;


  useEffect(() => {
    dispatch(preAfiliacionesTomadasLimpiar());
    dispatch(fetchPreAfilicionesTomadas());
  }, [dispatch]);

  const handleLiberarPreAfiliacion = id => {
    dispatch(liberarPreAfiliacion(id, 'admin'));
  }

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70, hide: true },
    //Quite el avatar para ver si ese es el error
    /*{
      field: '',
      headerName: '',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Avatar
          alt={params.getValue('usuario')?.userName}
          src={`${baseUrl}/${params.getValue('usuario')?.urlImagen}`}
        />
      ),
    },*/
    { field: 'nombreUsuario', headerName: 'Nombre Usuario', width: 175 },
    { field: 'idGrupoFamiliar', headerName: 'G. Familiar', width: 125 },
    { field: 'titular', headerName: 'Titular', width: /*200*/ 260 },
    { field: 'cuilTitular', headerName: 'Cuil', width: 130 },
    {
      field: 'fechaTomada',
      headerName: 'Fecha Tomada',
      width: 165,
      renderCell: (params) => {
        if (params !== null) {
          return new Date(params.getValue('fechaTomada')).toLocaleString(
            "es",
            optionsfecha
          );
        } else {
          return ''; // o cualquier otro valor predeterminado que desees
        }
      },
    },
    // { field: 'idUsuario', headerName: 'Id Usuario', width: 120, hide: true },
    {
      field: 'action',
      headerName: 'Accion',
      width: 110,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <strong>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => { handleLiberarPreAfiliacion(params.getValue('id')) }}
            disabled={!validarSoloUnPermiso(permisosUser, ADMINISTRAR_PREAFILIACIONES_PERMISOS.LIBERAR) &&
              params.getValue('idUsuario') !== idUsuario}
          >
            Liberar
          </Button>
        </strong>
      ),
    }
  ];

  return (
    <div>
      {/* {items.length > 0 && ( */}
      <Grid>
        <Grid container justify="center">
          <Card className={classes.card} >
            <Typography className={classes.tableTitle}>
              <strong>PreAfiliaciones Tomadas</strong></Typography>
            <div style={{ height: 400 }}>
              {cargada && <DataGrid
                rows={preAfiliacionesFiltradas}
                columns={columns}
                disableSelectionOnClick={true}
                pageSize={5}
                localeText={{
                  noRowsLabel: 'Sin registros',

                  toolbarDensity: "Tamaño",
                  toolbarDensityLabel: "Tamaño",
                  toolbarDensityCompact: "Chico",
                  toolbarDensityStandard: "Mediano",
                  toolbarDensityComfortable: "Grande",
                  toolbarColumns: "Columnas",
                  toolbarColumnsLabel: "Seleccion de Columnas",
                  toolbarFilters: "Filtros",
                  toolbarFiltersLabel: "Mostrar Filtros",
                  toolbarFiltersTooltipHide: "Ocultar Filtros",
                  toolbarFiltersTooltipShow: "Mostrar Filtros",
                  toolbarFiltersTooltipActive: (count) => `${count} Filtros Activos`,
                  // Columns panel text
                  columnsPanelTextFieldLabel: "Buscar columna",
                  columnsPanelTextFieldPlaceholder: "Columnas",
                  columnsPanelDragIconLabel: "Reordenar Columnas",
                  columnsPanelShowAllButton: "Mostrar Todas",
                  columnsPanelHideAllButton: "Ocultar Todas",

                  // Filter panel text
                  filterPanelAddFilter: "Agregar Filtros",
                  filterPanelDeleteIconLabel: "Eliminar",
                  filterPanelOperators: "Operador",
                  filterPanelOperatorAnd: "Y",
                  filterPanelOperatorOr: "O",
                  filterPanelColumns: "Columnas",

                  // Filter operators text
                  filterOperatorContains: "Contiene",
                  filterOperatorEquals: "Igual",
                  filterOperatorStartsWith: "Empieza con",
                  filterOperatorEndsWith: "temrina con",
                  filterOperatorIs: "es",
                  filterOperatorNot: "no es",
                  filterOperatorOnOrAfter: "despues",
                  filterOperatorBefore: "antes",
                  filterOperatorOnOrBefore: "antes",

                  // Column menu text
                  columnMenuLabel: "Menu",
                  columnMenuShowColumns: "Mostrar",
                  columnMenuFilter: "Filtros",
                  columnMenuHideColumn: "Ocultar",
                  columnMenuUnsort: "Deshacer",
                  columnMenuSortAsc: "Ordenar Asc",
                  columnMenuSortDesc: "Ordenar Desc",

                  // Column header text
                  columnHeaderFiltersTooltipActive: (count) =>
                    `${count} filtros activos`,
                  columnHeaderFiltersLabel: "Filtros",
                  columnHeaderSortIconLabel: "Ordenar",

                  // Rows selected footer text
                  footerRowSelected: (count) =>
                    count !== 1
                      ? `${count.toLocaleString()} rows selected`
                      : `${count.toLocaleString()} row selected`,

                  // Total rows footer text
                  footerTotalRows: "Total Registros:",

                  // Pagination footer text
                  footerPaginationRowsPerPage: "Registros por pagina:",
                }}
              />}
            </div>
          </Card>
        </Grid>
      </Grid>
      {/* )} */}
    </div>
  );

};
